var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "border" },
    [
      [
        _vm._l(_vm.warehouseList, function(row, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "warehouseList",
              class: [_vm.isWarehouseSelected(row) ? "selectedRow" : ""]
            },
            [
              _c(
                "div",
                { staticClass: "fields" },
                [
                  _c(
                    "sc-field",
                    { attrs: { label: "Centro de Distribuição" } },
                    [
                      _c("sc-input", {
                        attrs: { disabled: true, value: row.name }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-field",
                    { attrs: { label: "CNPJ" } },
                    [
                      _c("sc-input", {
                        attrs: {
                          disabled: true,
                          value: row.federal_tax_payer_id
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-field",
                    { attrs: { label: "CEP" } },
                    [
                      _c("sc-input", {
                        attrs: { disabled: true, value: row.address.zip_code }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "buttons" },
                [
                  !_vm.hasConfiguration
                    ? _c(
                        "sc-button",
                        {
                          attrs: { theme: "danger" },
                          on: {
                            click: function($event) {
                              _vm.removeRow(index)
                            }
                          }
                        },
                        [_vm._v("Excluir")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "sc-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.selectRow(row)
                        }
                      }
                    },
                    [_vm._v("Configuração")]
                  )
                ],
                1
              )
            ]
          )
        }),
        _vm._v(" "),
        !_vm.hasConfiguration
          ? _c(
              "div",
              [
                _c(
                  "sc-field",
                  { attrs: { label: "Centro de Distribuição" } },
                  [
                    _c(
                      "sc-select",
                      {
                        attrs: { loading: _vm.loading },
                        model: {
                          value: _vm.selected_warehouse,
                          callback: function($$v) {
                            _vm.selected_warehouse = $$v
                          },
                          expression: "selected_warehouse"
                        }
                      },
                      _vm._l(_vm.warehouses, function(warehouse, index) {
                        return _c(
                          "option",
                          {
                            key: index,
                            staticClass: "selectWarehouse",
                            attrs: {
                              disabled: _vm.isWarehouseInUse(warehouse)
                            },
                            domProps: { value: warehouse }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(warehouse.name) +
                                "\n          "
                            )
                          ]
                        )
                      })
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "sc-button",
                  {
                    attrs: { disabled: !_vm.selected_warehouse },
                    on: { click: _vm.addRow }
                  },
                  [_vm._v("Adicionar")]
                )
              ],
              1
            )
          : _vm._e()
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79755e88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79755e88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-warehouses-list/ScWarehousesList.vue
// module id = null
// module chunks = 